<template>
  <div>
    <div class="button-group d-flex">
      <template v-for="(mode, index) in modes">
        <b-button
            :key="mode"
            :variant="value === mode ? 'primary' : 'transparent'"
            :class="buttonClass(index)"
            style="border-radius: 4px"
            @click="onClick(mode)"
        >
          {{ lodash.upperFirst($t(`purchase_plans.modes.${mode}`)) }}
        </b-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'table-model-button-group',
  props: {
    value: {type: String, default: 'processing'}
  },
  data() {
    return {
      modes: ['advanced', 'simple'],
    }
  },
  methods: {
    buttonClass(index) {
      return {
        'ms-1': index > 0,
        'me-1': index < this.modes.length - 1,
      }
    },
    onClick(mode) {
      this.$emit('input', mode)
      this.$emit('click', mode)
    }
  }
}
</script>

<style scoped>
::v-deep {
  .btn {
    padding: 8px 16px;
    font: 600 14px/16px Lato, sans-serif;
    border-radius: 24px !important;
  }
}
.button-group {
  background-color: #F2F4F7;
  border-radius: 24px;
  padding: 4px;
  width: fit-content;
}
</style>